import { combineReducers } from 'redux';

import notificationList from './notification-list-reducer';
import emailTemplateDesigner from './template-designer-reducer';
import emailTemplatePicker from './template-picker-reducer';

const EmailIntegrationsReducer = combineReducers({
  notificationList,
  emailTemplateDesigner,
  emailTemplatePicker,
});

export default EmailIntegrationsReducer;
